/* eslint-disable no-eval */
import Vue, { CreateElement } from 'vue';
import VueClipboard from 'vue-clipboard2';
import * as Sentry from '@sentry/vue';
import dayjs from 'dayjs';
import normalizeWheel from 'normalize-wheel';
import VueCompositionApi from '@vue/composition-api';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store/index';
import config from '@/config';
import '@/plugins/viewUI';
import '@/plugins/flexTable';
import '@/plugins/vueLazyload';
import '@/plugins/vClickOutside';
import i18n from '@/locales/index';
import './registerServiceWorker';
import escapeHtml from 'escape-html';
import 'perfect-scrollbar/css/perfect-scrollbar.css';// 引入滚动条组件样式
// import log from '@/api/client/log';
// import { encodeBase64, localRead, sessionRead } from './libs/util';
import InfiniteScroll from './components/base/InfiniteScroll';
import PortalVue from 'portal-vue';
// import { extend } from 'lodash';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { VxeTable, VxeColumn, VxeGrid } from 'vxe-table';
import LogClient from './libs/log/LogClient';
import { VxeTooltip } from 'vxe-pc-ui';
import 'vxe-pc-ui/lib/style.css';

import 'vxe-table/lib/style.css';
import '@/styles/modules/VxeTable.css';
import Tooltip from './components/base/Tooltip.vue';
import PageLayout from './components/layout/PageLayout/index.vue';
import TabsLayout from './components/layout/TabsLayout/index.vue';

// 引导插件 start
import 'intro.js/introjs.css'; // introjs默认css样式
// 引导插件 end

/* 项目 index.less 默认放在所有引入 插件的 css 的下方，避免第三方插件样式影响自身 start */
import '@/styles/index.less';
/* 项目 index.less 默认放在所有引入 插件的 css 的下方，避免第三方插件样式影响自身 end */
import EnhancedXHR from '@/libs/EnhancedXHR';
import { isShellEmbedded } from '@/libs/util';
import initEmbeddedBridge from '@/libs/embedded-bridge';

const limits: any = {};

const triggerLimit = (url: string, count: number) => {
    console.log('请求异常过多，拦截：', url, count);
    if (Vue.prototype.$log && !limits[url]) {
        limits[url] = true;
        Vue.prototype.$log('WEB_NETWORK', 'HEAD_OFF_REQUEST', { data: { url, count } });
    }
};

EnhancedXHR.enable();
EnhancedXHR.setIsDebug(true);
EnhancedXHR.setBlackList(['https://fclog.baidu.com/log/ocpcagl'], triggerLimit);
EnhancedXHR.setMaxErrorCount(100);

Vue.use(VxeTooltip);
Vue.use(VxeTable).use(VxeColumn).use(VxeGrid);

Vue.use(PortalVue);
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.use(VueCompositionApi);
Vue.use(InfiniteScroll);
// @ts-ignore
Vue.use(VueVirtualScroller);

Vue.component('RecycleScroller', VueVirtualScroller.RecycleScroller);
Vue.component('DynamicScroller', VueVirtualScroller.DynamicScroller);
Vue.component('DynamicScrollerItem', VueVirtualScroller.DynamicScrollerItem);
Vue.component('PageLayout', PageLayout);
Vue.component('TabsLayout', TabsLayout);
// 直接覆盖 iview的 Tooltip
Vue.component('Tooltip', Tooltip);

Vue.config.productionTip = false;

Vue.prototype.$dayjs = dayjs;

Vue.prototype.$normalizeWheel = normalizeWheel;

Vue.prototype.$config = config;

window.FE_VERSION = VERSION;
window.VUE_VERSION = VUE_VERSION;
window.IVIEW_DESIGN = IVIEW_DESIGN;

Vue.prototype.$version = window.FE_VERSION;

Vue.prototype.$openFb = 'v2.2.4.1';

Vue.prototype.$checkAuth = (key: string) => {
    const { access } = store.state.user;
    return access.includes(key);
};
Vue.prototype.escapeHtml = escapeHtml;

Vue.prototype.$delYear = (time: string) => {
    const year = new Date().getFullYear();
    if (time) {
        if (time.indexOf(`${year}-`) > -1) {
            return time.replace(`${year}-`, '');
        }
        return time.replace(`${year - 1}-`, '');
    }
    return '-';
};

window.i18n = i18n;

Vue.prototype.$log = (logType: string, type: string, data: any = {}) => {
    let log_data = data;
    if (data.data) {
        log_data = data.data;
        delete data.data;
    }
    LogClient.addLog({
        log_type: logType,
        type,
        log_data,
    });
};

/**
 * 注册埋点 sd_track 事件
 * @param key 对应埋点key
 * @param customProperty 自定义属性（object）
 */
Vue.prototype.$sd_track = (key: string, customProperty: any) => {
    const _keyElement = document.querySelector(`[data-sd-track="${key}"]`);
    const sensors = window.sensorsDataAnalytic201505;
    if (_keyElement && sensors && sensors.quick) {
        const _customProperty = customProperty || null;
        if (_customProperty) {
            sensors.quick('trackAllHeatMap', _keyElement, {
                ..._customProperty,
            });
        } else {
            sensors.quick('trackAllHeatMap', _keyElement);
        }
    }
};

Vue.config.errorHandler = async (err, vm, info) => {
    // handle error
    // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
    console.error(err);

    // const params: any = {
    //     type: 'VUE_GLOBAL_ERROR',
    //     projectName: store.state.user.project,
    //     projectId: store.state.user.projectId,
    //     user_id: store.state.user.userId,
    //     token: localRead(config.tokenKey),
    //     version: (window as any).version,
    //     source_url: window.location.href,
    //     url: window.location.href,
    //     language: window.navigator.language,
    //     ua: window.navigator.userAgent,
    //     msg: err.message,
    //     stack: err.stack,
    // };

    const errorData = { info, err, err_meg: err.message, err_stack: err.stack };

    // const isCom = window.location.hostname.indexOf('salesmartly.com') > -1;
    // if (isCom) {
    //     params.log_data = errorData;
    // } else {
    //     params.data = errorData;
    // }

    // let logData: any = null;

    // try {
    //     logData = JSON.stringify(params);
    // } catch (e) {
    //     logData = JSON.stringify({
    //         type: 'VUE_GLOBAL_ERROR',
    //         projectName: store.state.user.project,
    //         projectId: store.state.user.projectId,
    //         user_id: store.state.user.userId,
    //         token: localRead(config.tokenKey),
    //         version: (window as any).version,
    //         source_url: window.location.href,
    //         url: window.location.href,
    //         language: window.navigator.language,
    //         ua: window.navigator.userAgent,
    //         msg: err.message,
    //         stack: err.stack,
    //     });
    // }

    // log({
    //     log_type: 'SS_VUE_ERROR',
    //     data: encodeBase64(logData),
    //     base_encode: '1',
    // }).catch(console.error);

    LogClient.addLog({
        log_type: 'SS_VUE_ERROR',
        type: 'VUE_GLOBAL_ERROR',
        log_data: errorData,
    });
};

// 监听全局 submit 事件，阻止表单的默认提交行为
document.addEventListener(
    'keydown',
    (event) => {
        const target = event.target as HTMLElement;
        if (event.key === 'Enter' && target.tagName === 'INPUT') {
            event.preventDefault(); // 阻止默认提交
        }
    },
    true,
);

// if (['production', 'pre'].includes((process.env.VUE_APP_CURRENTMODE as string) || '')) {
Sentry.init({
    dsn: 'https://4d68c4e1af6eecdfe9b5a68e7b534c90@sentry.salesmartly.com/2',
    integrations: [
        new Sentry.BrowserTracing({
            // 详情看 https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/#tracepropagationtargets
            tracePropagationTargets: [window.location.origin],

        }),
        new Sentry.VueIntegration({
            Vue,
            tracingOptions: {
                trackComponents: false, // trackComponents为true可以监控component的性能表现，打开这个会影响客户端性能
                timeout: 2000,
            },
            logErrors: true,
            attachProps: true,
        }),
        // new Sentry.Replay({
        //     maskAllText: false,
        //     blockAllMedia: false,
        // }),
    ],
    release: process.env.VUE_APP_VERSION,
    environment: process.env.VUE_APP_CURRENTMODE,
    // Performance Monitoring
    // tracesSampleRate: 1.0, // Capture 100% of the transactions
    tracesSampler: (samplingContext) => {
        const { transactionContext } = samplingContext;
        if (
            ['/chat'].includes(transactionContext.name) ||
            transactionContext.name.startsWith('/marketing/') ||
            transactionContext.name.startsWith('/channel/')
        ) {
            return 1.0; // 100% 的采样率
        }
        return 0.2;
    },
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
// }

new Vue({
    store,
    router,
    i18n,
    provide: {
        router,
        store,
    },
    render(h: CreateElement) {
        return h(App);
    },
}).$mount('#app');

initEmbeddedBridge(router);

if (isShellEmbedded()) {
    // 嵌入模式下禁止 html/body 产生滚动条，所有滚动由内部组件自行管理
    document.documentElement.classList.add('shell-embedded-root');
    document.body.classList.add('shell-embedded-root');

    window.addEventListener('embedded:logout', () => {
        console.log('[main] embedded:logout received, cleaning up...');
        // 兜底:强制 reload iframe,彻底清理所有状态
        window.location.reload();
    });
}

if (isShellEmbedded()) {
    try {
        window.parent.postMessage(
            {
                v: 1,
                type: 'iframe:ready',
                source: 'iframe',
                payload: { appName: 'mix_ads_fe' },
            },
            window.location.origin,
        );
    } catch (e) {
        console.error('[main] failed to post iframe:ready to parent', e);
    }
}

if ('caches' in window) {
    window.caches.keys().then((keyList) => {
        //! 临时代码 ，删除 service worker 缓存， 改用固定  cache name
        return Promise.all(keyList.map((key) => {
            if (key !== 'ss-runtime' && key !== 'ss-runtime-image') {
                return caches.delete(key);
            }
            return undefined;
        }));
    });
} else {
    // eslint-disable-next-line
    if (Vue.prototype.$log) {
        Vue.prototype.$log('SS_ERROR', 'NO_CACHES', { msg: 'window.caches' });
    }
}
